import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { SendIcon } from 'assets/icons';
import { BotpressService } from 'services';
import axios from 'axios';
import { EventSourcePolyfill as EventSource } from 'event-source-polyfill';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {};

class BotpressChat extends React.Component<Props> {
  messagesEnd: any = null;
  textareaRef: any = null;
  errorTimer: any = null;

  state = {
    messages: [],
    form: {
      message: '',
    },
    textareaHeight: 55.8,
    user_key: '',
    conversation_id: '',
    url: '',
    user_id: '',
    connection: {
      close: () => {},
    },
    remain_uses: 0,
    unlimited: 0 as number,
    plan_user: null,
    isTyping: false,
    hasError: false,
    lastMessage: '',
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Chat (IA)',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
  }

  componentWillUnmount() {
    this.state.connection.close();
  }

  load = async () => {
    const res: any = await BotpressService.get({
      user_id: this.props.user?.id,
    });

    await this.setState({
      url: res.url,
      user_key: res.data.token,
      conversation_id: res.data.conversation_id,
      user_id: res.data.botpress_id,
      remain_uses: res.remain_uses,
      unlimited: res.unlimited,
      plan_user: res.plan_user,
    });

    const isInternalLawyer =
      this.props.user?.level_id === Constants.LEVELS.LAWYER &&
      this.props.user?.internal === Constants.LAWYER_INTERNAL.YES;

    if (!res.plan_user && !isInternalLawyer) {
      this.props.history.replace('/');
      Globals.showError('Lo sentimos, debe tener una membresía activa');
    }

    const response: any = await axios
      .get(res.url + `conversations/${res.data.conversation_id}/messages`, {
        headers: {
          'x-user-key': res.data.token,
        },
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data);
        }
      });

    if (response.data?.messages) {
      this.setState(
        {
          messages: response.data.messages.reverse(),
        },
        () => {
          this.scrollToBottom();
          this.subscribe();
        },
      );
    }
  };

  scrollToBottom = () => {
    this.messagesEnd.scrollTo({
      behavior: 'smooth',
      top: this.messagesEnd.scrollHeight,
    });
  };

  subscribe = async () => {
    const es = new EventSource(
      this.state.url + `conversations/${this.state.conversation_id}/listen`,
      {
        // @ts-ignore
        headers: {
          'x-user-key': this.state.user_key,
        },
      },
    );

    this.setState({
      connection: es,
    });

    es.addEventListener('message', (event: any) => {
      console.log('BOTPRESS EVENT:', event); // <-- temporal
      if (typeof event.data === 'string') {
        try {
          console.log(event.data);
          const data: any = JSON.parse(event.data);

          const isBotReply = data.data?.userId !== this.state.user_id;

          if (isBotReply && this.errorTimer) {
            clearTimeout(this.errorTimer);
            this.errorTimer = null;
          }

          let messages: any = [...this.state.messages];
          messages.push(data.data);
          this.setState(
            {
              messages,
              ...(isBotReply ? { isTyping: false, hasError: false } : {}),
            },
            () => {
              this.scrollToBottom();
            },
          );
        } catch (e) {}
      }
    });
  };

  change = (e: any) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };

  autoGrow = (e: any) => {
    if (e.nativeEvent.keyCode == 13) {
      e.preventDefault();
      this.send();
    }
    this.textareaRef.style.height = 'inherit';
    this.textareaRef.style.height = `${Math.max(this.textareaRef.scrollHeight, 55.8)}px`;
  };

  send = async (retryMessage: string = '') => {
    const message = retryMessage || this.state.form.message;
    if (message) {
      if (this.errorTimer) {
        clearTimeout(this.errorTimer);
        this.errorTimer = null;
      }

      this.setState({
        form: {
          ...this.state.form,
          message: '',
        },
        isTyping: true,
        hasError: false,
        lastMessage: message,
      });

      const res: any = await BotpressService.send({
        user_id: this.props.user?.id,
        withoutLoading: true,
      });

      if (res.remain_uses) {
        this.setState({
          remain_uses: res.remain_uses,
          unlimited: res.unlimited,
        });
      }

      this.errorTimer = setTimeout(() => {
        this.setState({
          isTyping: false,
          hasError: true,
        });
      }, 30000);

      axios
        .post(
          this.state.url + 'messages',
          {
            payload: {
              text: message,
              type: 'text',
            },
            userId: this.state.user_id,
            conversationId: this.state.conversation_id,
          },
          {
            headers: {
              'x-user-key': this.state.user_key,
              'Content-Type': 'application/json',
            },
          },
        )
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
          }
          if (this.errorTimer) {
            clearTimeout(this.errorTimer);
            this.errorTimer = null;
          }
          this.setState({
            isTyping: false,
            hasError: true,
          });
        });
    }
  };

  dismissError = () => {
    if (this.errorTimer) {
      clearTimeout(this.errorTimer);
      this.errorTimer = null;
    }
    this.setState({ hasError: false, isTyping: false });
  };

  render() {
    const { messages, isTyping, hasError } = this.state;
    const plan_user: any = this.state.plan_user;

    return (
      <div id='client-botpress-chat'>
        <div className='rest-messages'>
          {/*
					// @ts-ignore */}
          <p>
            Mensajes restantes:{' '}
            {this.state.unlimited == Constants.UNLIMITED.YES ? 'Ilimitado' : this.state.remain_uses}
          </p>
        </div>
        <div
          className='container-messages'
          ref={(el) => {
            this.messagesEnd = el;
          }}
        >
          {messages.map((item: any) => {
            const _self = item.userId == this.state.user_id;

            return (
              <div className={`item-message ${_self ? 'self' : ''}`}>
                <p className='message'>{item.payload?.text}</p>
              </div>
            );
          })}

          {this.state.messages.length == 0 && (
            <div className='text-center'>
              <p className='no-messages'>
                Hola, estoy para ayudarte indícame tu consulta legal y te ayudaré
              </p>
            </div>
          )}

          {isTyping && (
            <div className='typing-indicator'>
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}

          {hasError && (
            <div className='error-banner'>
              <p className='error-text'>
                ⚠️ Ocurrió un error al obtener la respuesta. Por favor, intenta de nuevo.
              </p>
              <div className='error-actions'>
                <button className='btn-retry' onClick={() => this.send(this.state.lastMessage)}>
                  Reintentar
                </button>
                <button className='btn-dismiss' onClick={this.dismissError}>
                  ✕
                </button>
              </div>
            </div>
          )}
        </div>
        <div style={{ padding: '20px' }}>
          <div className='container-textarea'>
            <textarea
              className='form-control'
              ref={(ref) => (this.textareaRef = ref)}
              rows={1}
              value={this.state.form.message}
              placeholder={isTyping ? 'Esperando respuesta...' : 'Escribir'}
              name='message'
              disabled={isTyping}
              style={{
                minHeight: 38,
                resize: 'none',
              }}
              onKeyDown={(e: any) => this.autoGrow(e)}
              onChange={this.change}
            />
            <button className='btn' disabled={isTyping} onClick={() => this.send()}>
              <img src={SendIcon} className='send-icon' />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(BotpressChat);
